import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Order } from '../Module/Order.model';
import { OrderService } from '../service/order.service';
import { DatePipe } from '@angular/common';
import { ClientService } from '../service/client.service';
import { PaymentDetails } from '../Module/PayementDetails.model';
import { StateService } from '../service/state.service';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { LoaderService } from '../service/loader.service';
import { MatDialog } from '@angular/material/dialog';
import { ReturnOrderComponent } from '../return-order/return-order.component';

@Component({
  selector: 'app-order-list',
  templateUrl: './order-list.component.html',
  styleUrls: ['./order-list.component.css']
})
export class OrderListComponent implements OnInit, OnDestroy {

  ordersToDisplay: Order[] = [];
  currentPage = 1;
  ordersPerPage = 40;
  paymentDetails = { paid: 0, unpaid: 0 };
  orderSize!: number;
  intialOrderSize!: number;
  pages: number[] = [];
  clientCount!: number;
  selectedStatus: string = '';
  query: string = '';
  selectedDate: string = '';
  isTableLoading: boolean = false;

  constructor(
    private renderer: Renderer2,
    private orderService: OrderService,
    private datePipe: DatePipe,
    private clientService: ClientService,
    private stateService: StateService,
    private route: Router,
    private loaderService: LoaderService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.renderer.addClass(document.body, 'your-component-bg');
    this.isTableLoading = true;

    forkJoin({
      clientCount: this.clientService.countClients(),
      orderCount: this.orderService.countOrders(),
      paymentSummary: this.orderService.getPaymentSummary(),
      pagedOrders: this.orderService.getPagedOrders(0, this.ordersPerPage, this.query, this.selectedStatus, this.selectedDate)
    }).subscribe({
      next: ({ clientCount, orderCount, paymentSummary, pagedOrders }) => {
        this.clientCount = clientCount;
        this.orderSize = orderCount;
        this.intialOrderSize = orderCount;
        this.paymentDetails = {
          paid: paymentSummary.paid,
          unpaid: paymentSummary.unpaid
        };
        this.ordersToDisplay = pagedOrders.content;
        this.pages = Array.from({ length: pagedOrders.totalPages }, (_, i) => i + 1);
        this.currentPage = 1;
        this.isTableLoading = false;
      },
      error: () => {
        this.isTableLoading = false;
        console.error('Erreur lors du chargement des données');
      }
    });
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'your-component-bg');
  }

  getOrders(page: number): void {
    this.isTableLoading = true;
    this.orderService.getPagedOrders(page, this.ordersPerPage, this.query, this.selectedStatus, this.selectedDate)
      .subscribe({
        next: data => {
          this.ordersToDisplay = data.content;
          this.orderSize = data.totalElements;
          this.pages = Array.from({ length: data.totalPages }, (_, i) => i + 1);
          this.currentPage = page + 1;
          this.isTableLoading = false;
        },
        error: () => {
          this.isTableLoading = false;
        }
      });
  }

  filterOrders(): void {
    this.getOrders(0);
  }

  onPageChange(page: number): void {
    this.getOrders(page - 1);
  }

  onInputChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    this.query = inputElement.value;
    this.filterOrders();
  }

  onDateChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    this.selectedDate = inputElement.value;
    this.filterOrders();
  }

  onStatusChange(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    this.selectedStatus = selectElement.value;
    this.filterOrders();
  }

  isOrderPaid(order: Order): boolean {
    return order.isPaid?.toString() === 'true';
  }

  setOrderDate(order: Order): string {
    return this.datePipe.transform(order.orderDate, 'dd MMMM, yyyy') || '';
  }

  getClientInitials(firstName?: string, lastName?: string): string {
    return ((firstName?.charAt(0) || '') + (lastName?.charAt(0) || '')).toUpperCase();
  }

  getTooltip(order: Order): string {
    if (!order.orderLines) return '';
    return order.orderLines
      .map(line => `${line.product?.name}: ${line.quantity} x ${line.product?.price} MAD`)
      .join('\n');
  }

  openClientFormDialog() {
    this.stateService.openClientFormDialog();
  }

  goToOrderDetails(order: Order): void {
    const url = `/orderDetails?id=${order.id}`;
    window.open(url, '_blank');
  }

  goToOrderEdit(order: Order): void {
    const url = `/updateOrder?id=${order.id}`;
    window.open(url, '_blank');
  }

  openReturnDialog(order: Order): void {
    const dialogRef = this.dialog.open(ReturnOrderComponent, {
      width: '1000px',
      maxWidth: '95vw',
      data: { order: order },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Refresh the list and stats if return was successful
        this.ngOnInit();
      }
    });
  }
}
